/**
 * Every word the waitlist and the privacy notice show (DWLF-584), in one place so the copy can be
 * read and approved as a whole. Retail is invite-only while the market-data licence forbids open
 * sign-up; these screens are what a visitor who cannot get in sees instead of an error.
 */

export const YOUTUBE_URL = 'https://www.youtube.com/@DWLF-SFN';

/**
 * The privacy notice's version, YYYY-MM-DD (the shape dwlf-retail-api accepts): a label, normally
 * the day it was written, never reused. Each join sends it, so the entry records which notice the
 * person agreed to. Change it whenever the notice's text changes (privacyNoticeVersion.test.js).
 */
export const PRIVACY_NOTICE_VERSION = '2026-10-31';

export const WAITLIST_COPY = {
  heading: 'DWLF is invite-only for now',
  intro: "We're finishing our data licensing. Join the waitlist and we'll let you know as soon as we open.",
  refusedGoogle: "This Google account hasn't been invited yet.",
  refusedLegacy: 'New sign-ups are closed for now.',
  emailLabel: 'Email',
  interestsLabel: 'What are you most interested in? (optional)',
  interests: [
    { value: 'stocks', label: 'Stocks' },
    { value: 'crypto', label: 'Crypto' },
    { value: 'metals', label: 'Metals' },
    { value: 'ai_agents', label: 'AI agents' },
  ],
  consent: 'Email me when DWLF opens to new members. I can unsubscribe at any time.',
  privacyBefore: 'We use your email only to tell you when access opens. See our ',
  privacyLink: 'privacy notice',
  privacyAfter: '.',
  submit: 'Join the waitlist',
  submitting: 'Joining…',
  joinedHeading: "You're on the list",
  joinedBody: "We'll email you when DWLF opens up. That's the only email we'll send you.",
  youtube: 'While you wait, see how DWLF works on YouTube →',
  cta: 'Join the waitlist',
  noInviteLink: 'Not invited yet? Join the waitlist',
  differentAccount: '← Sign in with a different Google account',
  errors: {
    email: 'Enter a valid email address.',
    consent: 'Tick the box so we can email you when access opens.',
    busy: 'Too many tries from here. Please try again in an hour.',
    failed: "Something went wrong and you're not on the list yet. Please try again.",
  },
};
